import React, { useState } from 'react';
import { Link, useLocation } from "react-router-dom";
import './HeaderMobile.css'
import HeaderDropdownItem from './HeaderDropdownItem'
import dropDownMenu from '../pics/drop_down_menu.svg'
import DropdownClose from '../pics/x.svg';

const mapping = {
  '/': 0,
  '/about': 1,
  '/newsblogs': 2,
  '/members': 3,
  '/sponsorship': 4,
  '/contact': 5
}

const HeaderMobile = () => {
  const [isOpen, setIsOpen] = useState(false);

  const location = useLocation().pathname;
  const location_index = mapping[location];
  const [selectedItem, setSelectedItem] = useState(location_index);
  
  // console.log("location", location_index)

  const handleItemClick = (index) => {
    setSelectedItem(index);
    setIsOpen(false);
  };

  return (
    <div className='header-dropdown'>
      <div className='logo-area'>
        <Link to={'/'}  className='logo-picture' 
            onClick={() => { 
              window.scroll(0, 0);
              setSelectedItem(0);
            }}>
            <img className='logo' alt="logo" /> 
        </Link>
        <div className="header-dropdown-button" onClick={() => setIsOpen(!isOpen)}>
              <img src={isOpen? DropdownClose: dropDownMenu} className={isOpen? "close-button-img": "open-button-img"}/>
        </div>
      </div>
  
      <div className='header-dropdown-area'>
        {isOpen && (
          <div className="header-dropdown-content">
            <HeaderDropdownItem to={"/"} text='Home' index={0} selectedItem={selectedItem} onClick={handleItemClick}/>
            <HeaderDropdownItem to={"/about"} text='About' index={1} selectedItem={selectedItem} onClick={handleItemClick}/>
            <HeaderDropdownItem to={"/newsblogs"} text='Press Release' index={2} selectedItem={selectedItem} onClick={handleItemClick}/>
            <HeaderDropdownItem to={"/members"} text='Our Members' index={3} selectedItem={selectedItem} onClick={handleItemClick}/>
            <HeaderDropdownItem to={"/sponsorship"} text='Sponsorship' index={4} selectedItem={selectedItem} onClick={handleItemClick}/>
            <HeaderDropdownItem to={"/contact"} text='Contact Us' index={5} selectedItem={selectedItem} onClick={handleItemClick}/>
          </div>
        )}
      </div>
    </div>
  );
}
  
export default HeaderMobile;
